module.exports = __webpack_public_path__ + "static/media/logo-solid.3c58cf66.svg";